import { Button } from 'common/components/Button/Button'
import { BUTTON_MODIFIER, BUTTON_PROPORTION } from 'common/constants/buttonConstants'

import styles from './confirm-cancel-view.module.scss'

type Props = {
  onConfirm: () => void
  onCancel: () => void
  isCancelling: boolean
}

const TITLE = 'Are you sure you want to cancel?'

export const ConfirmCancelView = ({ onConfirm, onCancel, isCancelling }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.textGroup}>
        <h3 className={styles.title}>{TITLE}</h3>
      </div>
      <div className={styles.footer}>
        <Button
          proportion={BUTTON_PROPORTION.LARGE}
          onClick={onConfirm}
          disabled={isCancelling}
          loading={isCancelling}
          className={styles.confirmButton}>
          Yes
        </Button>
        <Button
          modifier={BUTTON_MODIFIER.SECONDARY}
          proportion={BUTTON_PROPORTION.LARGE}
          onClick={onCancel}
          disabled={isCancelling}
          className={styles.cancelButton}>
          No
        </Button>
      </div>
    </div>
  )
}
